/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ExpertServiceQueryVariables = Types.Exact<{
    mpvId: Types.Scalars['String'];
}>;

export type ExpertServiceQuery = {
    __typename: 'Query';
    expertService: {
        __typename: 'ExpertService';
        isOverflowEligible: boolean;
        serviceProduct: { __typename: 'ServiceProduct'; mpvId: string };
    };
};

export const ExpertServiceDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ExpertService' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'mpvId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expertService' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'mpvId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'mpvId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isOverflowEligible' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'serviceProduct' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mpvId' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useExpertServiceQuery__
 *
 * To run a query within a React component, call `useExpertServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertServiceQuery({
 *   variables: {
 *      mpvId: // value for 'mpvId'
 *   },
 * });
 */
export function useExpertServiceQuery(
    baseOptions: Apollo.QueryHookOptions<ExpertServiceQuery, ExpertServiceQueryVariables>
) {
    return Apollo.useQuery<ExpertServiceQuery, ExpertServiceQueryVariables>(
        ExpertServiceDocument,
        baseOptions
    );
}
export function useExpertServiceLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ExpertServiceQuery, ExpertServiceQueryVariables>
) {
    return Apollo.useLazyQuery<ExpertServiceQuery, ExpertServiceQueryVariables>(
        ExpertServiceDocument,
        baseOptions
    );
}
export type ExpertServiceQueryHookResult = ReturnType<typeof useExpertServiceQuery>;
export type ExpertServiceLazyQueryHookResult = ReturnType<typeof useExpertServiceLazyQuery>;
export type ExpertServiceQueryResult = Apollo.QueryResult<
    ExpertServiceQuery,
    ExpertServiceQueryVariables
>;
